export default {
	checkBoxRow: { 
		display: 'flex', 
		gap: '20px' 
	},
	red: {
		color: '#ff4400'
	},
	flex: {
		display: 'flex',
		flexDirection: 'column',
		alignItems: 'flex-start',
	},
	container: {
		display: 'flex', 
		flexDirection: 'column', 
		gap: '30px'
	}
}